import { EARLY_ACCESS_TO_NEW_IN } from "../../../modules/category/constants";

const getEnableComplianceVariantFromConfig = (config = {}) => {
  const benefit = config?.benefits?.find(
    benefit => benefit.type === EARLY_ACCESS_TO_NEW_IN
  );

  return !!benefit?.metadata?.enableComplianceVariant;
};

export default getEnableComplianceVariantFromConfig;
